export function Chip({
  selected,
  label,
  onClick,
}: {
  selected: boolean;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={`min-h-11 rounded-xl border px-3 py-2 text-sm font-medium transition-colors ${
        selected
          ? "border-funnel-coral bg-funnel-coral text-white"
          : "border-funnel-ink/20 bg-white text-funnel-ink hover:border-funnel-coral"
      }`}
    >
      {label}
    </button>
  );
}
